import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AnessaTranslationService } from '../../../../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../../../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-checklist-template-dialog',
  templateUrl: './checklist-dialog.component.html',
  styleUrls: [
    './checklist-template-dialog.component.scss',
  ]
})
export class ChecklistTemplateDialogComponent extends UserpilotReloader {

  templateID = null;
  isTemplateDelete = false;

  projectTemplates = null;
  templateType: string = null;
  @ViewChild('loadList') loadList: any;
  greenButtonText = '-';

  constructor(
    private dialogRef: MatDialogRef<ChecklistTemplateDialogComponent>,
    private translationService: AnessaTranslationService,
    @Inject(MAT_DIALOG_DATA) private data: { templates: { name: string, templateid: string }, templateType: string },
  ) {
    super();
    if (data) {
      if (data.templates) this.projectTemplates = data.templates;
      if (data.templateType) this.templateType = data.templateType;
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onSend() {
    this.dialogRef.close({ templateID: this.templateID, isTemplateDelete: this.isTemplateDelete });
  }

  onRemoveTemplate(id: string) {
    this.isTemplateDelete = true;
    this.templateID = id;
    this.onSend();
  }

  setLoadID(id: string) {
    this.templateID = id;
    this.greenButtonText = this.translationService.get('COMMON.LOAD');
    this.isTemplateDelete = false;
  }
}
